import mBaseModel from '@/models/mBaseModel';
import UtilsData  from '@/utilities/UtilsData';
import formatter  from '@/utilities/Formatter';

export default class mDealCirtLiabilityStepDown extends mBaseModel {
  constructor(rawModelFields = {}) {
    super(rawModelFields);
    const ats = this.ats;
    // ##################################################
    // region UI fields from Create CIRT page
    ats.StartPeriod          = null;
    ats.EndPeriod            = null;
    ats.Reassess             = 0;
    ats.BalanceMultiplier    = null;
    ats.DelinquentMultiplier = null;
    // endregion UI fields from Create CIRT page
    // ##################################################
    this.setRawFields(rawModelFields);
  }

  setRawFields(rawModelFields = {}) {
    for (let prop of Object.keys(rawModelFields)) {
      if (this.ats.hasOwnProperty(prop)) {
        switch (prop) {
          case 'BalanceMultiplier':
          case 'DelinquentMultiplier':
            this.ats[prop] = formatter.formatAsNumber(rawModelFields[prop], { minSignsAfterDot: 2, maxSignsAfterDot: 8 });
            break
          default:
            this.ats[prop] = rawModelFields[prop];
            break;
        }
      }
    }
    return this;
  }

  // ##################################################
  // region Static Data
  static vocDbToLabel(dbName = null) {
    const ats = {};
    // ##################################################
    // region UI fields from Create CIRT page
    ats.StartPeriod          = 'Start Period';
    ats.EndPeriod            = 'End Period';
    ats.Reassess             = 'Reassess';
    ats.BalanceMultiplier    = 'Balance Multiplier';
    ats.DelinquentMultiplier = 'Delinquent Multiplier';
    // endregion UI fields from Create CIRT page
    // ##################################################
    if (dbName) {
      return ats?.[dbName];
    }
    return ats;
  }

  // endregion Static Data
  // ##################################################
  // region CRUD
  // endregion CRUD
  // ##################################################
  // region Validation
  validate() {
    this._localValidationStatus  = true;
    this._localValidationResults = [];
    const modelName              = `CIRT`;
    const id                     = this.ats.Id;
    // #####
    // ToDo: Validation.
    if (UtilsData.isEmpty(this.ats.Name)) this._localValidationResults.push({ field: 'Name', msg: 'Field is required', modelName: modelName, id: id });
    // #####
    this._localValidationStatus = this._localValidationResults.length === 0;
    return this._localValidationResults;
  }

  // endregion Validation
  // ##################################################
}
